import { IS_WORKER } from '../constants/isWorker'
import { IS_SERVER } from '../constants/ssr'
import { COOKIE_ERROR, ftGetLocalStorage, ftSetLocalStorage } from './common'

export function getPanelPinStatus(panel) {
  try {
    if (IS_SERVER || IS_WORKER) {
      return false
    }
    const panelStatus = ftGetLocalStorage('__ftPanelState')
    if (!panelStatus) {
      ftSetLocalStorage('__ftPanelState', JSON.stringify({ [panel]: false }))
      return false
    } else {
      try {
        let state = JSON.parse(panelStatus)
        return state[panel] ?? false
      } catch (error) {
        return false
      }
    }
  } catch (err) {
    console.error(COOKIE_ERROR)
  }
  return false
}

export function setPanelPinStatus(panel, status) {
  try {
    const panelStatus = ftGetLocalStorage('__ftPanelState')
    if (!panelStatus) {
      ftSetLocalStorage('__ftPanelState', JSON.stringify({ [panel]: false }))
      return false
    } else {
      try {
        let state = JSON.parse(panelStatus)
        state[panel] = status
        ftSetLocalStorage('__ftPanelState', JSON.stringify(state))
      } catch (error) {
        ftSetLocalStorage('__ftPanelState', JSON.stringify({ [panel]: false }))
      }
    }
  } catch (err) {
    console.error(COOKIE_ERROR)
  }
  return false
}

export function getPanelsInitialState() {
  let defState = {
    view: 'Basic',
  }
  try {
    if (IS_SERVER || IS_WORKER) {
      return defState
    }
    const panelStatus = ftGetLocalStorage('__ftPanelState')
    if (!panelStatus) {
      return defState
    } else {
      try {
        let state = JSON.parse(panelStatus)
        _.each(state, (v, k) => {
          defState[k] = defState[k] || {}
          defState[k].pin = v
        })
        return defState
      } catch (error) {
        return defState
      }
    }
  } catch (err) {
    console.error(COOKIE_ERROR)
  }
  return defState
}
